import Icon from '@/atoms/Icon'
import formatSlotDate from '@/helpers/formatSlotDate'

function ContestDateTile({ title, date }: ContestDateTileProps) {
  return (
    <div className="flex space-x-2 ">
      <span>
        <Icon className="w-5 h-5 text-sbtyellow-500" name="calendar" />
      </span>
      <span>
        <h5 className="text-[15px] font-medium">{title}</h5>
        <p className="mt-1 text-[14px] text-sbtgray-400">
          {date ? formatSlotDate(date).eventDate : 'Brak danych'}
        </p>
      </span>
    </div>
  )
}

interface ContestDateTileProps {
  title: string
  date: string
}

export default ContestDateTile
